import { makeStyles } from '@material-ui/core/styles';
import PoppinsRegular from '../../../../../assets/fonts/Poppins/Poppins-Regular.ttf'
import EncodeSansSemiBold from '../../../../../assets/fonts/Encode_Sans/EncodeSans-SemiBold.ttf'
import EncodeSansRegular from '../../../../../assets/fonts/Encode_Sans/EncodeSans-Regular.ttf'
import PoppinsMedium from '../../../../../assets/fonts/Poppins/Poppins-Medium.ttf';
import EncodeSansLight from "../../../../../assets/fonts/Encode_Sans/EncodeSans-Light.ttf";
export default makeStyles(theme => ({
  //MODAL STYLES
  field: {
    margin: "8px 4px",
  },
  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.6)",
  },
  modalMainMobile: {
    zIndex: "1000",
    backgroundColor: "#fff",
    borderRadius: "20px",
    boxShadow: "5px 10px 18px #888888",
    padding:"10px",
    position: "fixed",
    background: "#fff",
    width: "80%",
    height: "auto",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "block",
  },
  modalMainDesktop: {
    zIndex: "1000",
    backgroundColor: "#fff",
    borderRadius: "20px",
    boxShadow: "5px 10px 18px #888888",
    padding:"10px",
    position: "fixed",
    background: "#fff",
    width: "500px",
    height: "auto",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "block",
  },
  modalButtonConfirm: {
    borderRadius: "30px",
    color: "#fff",
    fontSize: "16px",
    background: "#BB0D66",
    padding: "4px 8px 4px 8px",
    marginLeft: "4px",
    marginRight: "4px",
    textDecoration:"none",
    border: "solid #BB0D66 0px",
    fontFamily: EncodeSansLight,
    '&:hover': {
      backgroundColor: "#000000",
    },
  },
  modalButtonModify: {
    borderRadius: "30px",
    color:"#fff",
    fontSize: "16px",
    backgroundColor: "#9A9A9A",
    padding: "4px 8px 4px 8px",
    marginLeft: "4px",
    marginRight: "4px",
    textDecoration:"none",
    border: "solid #BB0D66 0px",
    fontFamily: EncodeSansLight,
    '&:hover': {
      backgroundColor: "#000000",
    },
  },
//END MODAL STYLES
  buttonForm: {
    borderRadius: "30px",
    color: "#fff",
    fontSize: "16px",
    background: "#BB0D66",
    padding: "5px 15px 5px 15px",
    marginLeft: "auto",
    marginRight: "auto",
    textDecoration:"none",
    border: "solid #BB0D66 0px",
    fontFamily: EncodeSansLight,
    '&:hover': {
      backgroundColor: "#000000",
    },
  },
  modalTitle: {
    fontFamily: "Poppins",
    fontWeight:600,
    fontSize: "20px",
    color:"#bb0d66",
    textAlign: "center"
  },
  modalColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems:"center",
    justifyContent: "space-evenly",
  },
  modalSubtitle: {
    fontFamily: "Poppins",
    fontWeight: "700",
    fontSize: "16px",
    textAlign:"center"
  },
  modalText: {
    textAlign:"center",
    fontFamily: "Poppins",
    fontWeight: "200",
    letterSpacing:'-0.8',
    fontSize: "16px",
    maxWidth:"85%",
  },
  modalText2: {
    textAlign:"center",
    fontFamily: "Poppins",
    fontWeight: "200",
    letterSpacing:'-0.8',
    fontSize: "16px",
  },
  modalErrorTextContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    margin: "16px 0"
  },
  modalErrorText: {
    textAlign:"center",
    fontFamily: "Poppins",
    fontWeight: "200",
    letterSpacing:'-0.8',
    marginTop: "16px",
    maxWidth: "80%",
    alignSelf: "center",
    fontSize: "12px",
    color: "#B2BEB5"
  },
  iconCircle: {
    clipPath: "circle(25px at 50% 50%)",
    background:"#bb0d66"
  },
  formBox: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    padding:"32px",
    width:"800px",
    boxShadow: "5px 10px 18px #888888",
  },
  poppinsFont: {
    fontFamily: "PoppinsRegular",
    color: "#000",
  },
  EncodeSansFont: {
    fontFamily: "EncodeSansRegular",
    color: "#000",
  },
  verDetalles: {
    fontFamily: "EncodeSansRegular",
    marginLeft:"50px",
    color: "#bb0d66",
    fontSize:"12px",
  },
  radioCheck: {
    borderRadius: "50%",
    width: "30px",
    height: "30px",
    border: "1px solid #000000",
    transition: "0.2s all linear",
    marginRight:"16px",
    position: "relative",
    top:"16px",
    '&:checked': {
      border: "10px solid #bb0d66",
    },
  },
  inputTextArea: {
    width:"100%",
    height:"120px"
  },
  formBoxMobile: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    width:"90%",
    padding:"24px",
    boxShadow: "5px 10px 18px #888888",
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
    iconColor: '#452d7b',
  },
  buttons: {
    display: 'flex',
    flexDirection:"row",
    justifyContent: 'center'
  },
  buttonContained: {
    borderRadius:"30px",
    color:"#fff",
    fontSize: "16px",
    backgroundColor: "#BB0D66",
    marginLeft: "5px",
    marginRight: "5px",
    marginTop:"20px",
    border: "solid #BB0D66 0px",
    '&:hover': {
      backgroundColor: "#000000",
    },
  },
  backButton: {
    borderRadius:"30px",
    color:"#fff",
    fontSize: "16px",
    backgroundColor: "#9A9A9A",
    marginLeft: "5px",
    marginRight: "5px",
    marginTop:"20px",
    border: "solid #BB0D66 0px",
    '&:hover': {
      backgroundColor: "#000000",
    },
  },
}));
